import React from "react";
import { RCCProviderToast } from "react-common-components";
import { useTranslation } from "../Translations/context";

const ToastProvider: React.FC = ({children}) => {
	const { translate } = useTranslation();
	return (
		<RCCProviderToast translate={translate} direction="left" directionOffset={3.5}>
			{children}
		</RCCProviderToast>
	);
};

export default ToastProvider;
